module.exports = __webpack_public_path__ + "static/media/loewy-2.ae45d4f5.jpg";